export default {
  pids: {
    label: '添加位置',
    slotName: 'menuList',
  },
  icon: {
    label: '菜单图标',
    type: 'select',
    optionList: [
      { label: 'user', value: 'user' },
      { label: 'setting', value: 'setting' },
      { label: 'solution', value: 'solution' },
      { label: 'team', value: 'team' },
      { label: 'safety', value: 'safety' },
      { label: 'wallet', value: 'wallet' },
      { label: 'folder', value: 'folder' },
      { label: 'lock', value: 'lock' },
      { label: '无', value: '' },
    ],
  },
  name: {
    label: '菜单名称',
    type: 'input',
    rules: [{ required: true, message: '请选择菜单名称' }], // 校验
  },
  url: {
    label: '页面地址',
    type: 'input',
  },
  order: {
    label: '显示顺序',
    type: 'input',
  },
  code: {
    label: '权限代码',
    type: 'input',
  },
  index: {
    label: '菜单索引',
    type: 'input',
  },
  display: {
    label: '是否显示',
    type: 'select',
    optionList: [
      { label: '是', value: 1 },
      { label: '否', value: 2 },
    ],
  },
}
